<template>
  <b-row class="grab">
    <b-col class="col-main-pad">
      <b-row>
        <b-col lg="12" class="col-head-activity">
          <font-awesome-icon icon="adjust" />
          &nbsp; Configurar Flashcards
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">Instrucciones de la Actividad</label>
            <b-form-textarea
              v-model="instrucciones"
              placeholder="Ingrese las Instrucciones para Realizar la Actividad"
              rows="2"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">No. de Cartas</label>
            <b-form-select
              :value="defaultSelected"
              id="cartasNumero"
              class="border-visible"
              :options="noCartas"
              @change="onChangeCartas($event)"
              variant="primary"
            >
              <template slot="first">
                <option :value="null" disabled>Seleccione un Número</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="3" v-for="(carta,index) in cartasSelected" :key="carta.id">
          <b-card show-header show-footer>
            <div>
              <p>
                <strong>Anverso</strong>
                <i class="icon-close close-style" @click="removeCarta(index)"></i>
              </p>
              <b-form-select
                :value="carta.tipo"
                :id="`cartaTipo-${carta.id}`"
                :options="tipos"
                :name="`cartaTipo-${carta.id}`"
                @change="onChangeTipo($event, carta)"
              ></b-form-select>
            </div>
            <div v-if="carta.tipo == 1" style="height: 220px;">
              <b-form-textarea
                v-model="carta.data"
                placeholder="Agregue Texto"
                rows="8"
                max-rows="8"
                class="textarea"
              ></b-form-textarea>
            </div>
            <div v-if="carta.tipo == 2">
              <button
                type="button"
                class="btn btn-primary btn-select-recurso"
                @click="openModalRecursos('IMAGEN',carta)"
              >Seleccionar un Recurso</button>
              <div id="preview">
                <b-img
                  v-if="carta.data != ''"
                  thumbnail
                  fluid
                  :src="$root.setUrlFile(carta.data)"
                  alt="Imagen"
                  style="width: 160px; height: 160px;"
                ></b-img>
              </div>
            </div>
            <div slot="footer">
              <div>
                <p>
                  <strong>Reverso</strong>
                </p>
                <b-form-select
                  :value="carta.tipo2"
                  :id="`cartaTipo2-${carta.id}`"
                  :options="tipos"
                  :name="`cartaTipo2-${carta.id}`"
                  @change="onChangeTipo2($event, carta)"
                ></b-form-select>
              </div>
              <div v-if="carta.tipo2 == 1" style="height: 220px;">
                <b-form-textarea
                  v-model="carta.reverso"
                  placeholder="Agregue Texto"
                  rows="8"
                  max-rows="8"
                  class="textarea"
                ></b-form-textarea>
              </div>
              <div v-if="carta.tipo2 == 2">
                <button
                  type="button"
                  class="btn btn-primary btn-select-recurso"
                  @click="openModalRecursos2('IMAGEN',carta)"
                >Seleccionar un Recurso</button>
                <div id="preview">
                  <b-img
                    v-if="carta.reverso != ''"
                    thumbnail
                    fluid
                    :src="$root.setUrlFile(carta.reverso)"
                    alt="Imagen"
                    style="width: 160px; height: 160px;"
                  ></b-img>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col lg="12" style="text-align: right;">
          <button type="button" class="btn btn-primary" @click="newCarta">
            <i class="icon-plus"></i>&nbsp;Nueva Carta
          </button>
        </b-col>
      </b-row>
    </b-col>
    <!-- componente de botón de opciones del elemento  -->
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
    <!-- Modal recursos -->
    <ModalRecursos
      :showModal="showModal"
      v-on:closeModal="showModal = $event"
      :typeRecurso="typeRecurso"
      v-on:data-selected="chooseRecurso($event)"
    ></ModalRecursos>
    <ModalRecursos
      :showModal="showModal2"
      v-on:closeModal="showModal2 = $event"
      :typeRecurso2="typeRecurso2"
      v-on:data-selected="chooseRecurso2($event)"
    ></ModalRecursos>
  </b-row>
</template>

<script>
var arry = new Array(51);
var noCartas = [];
for (let i = 1; i < arry.length; i++) {
  noCartas.push(i);
}
import ModalRecursos from "@/components/ModalRecursos/";
import OptionsElement from "./OptionsElement";

export default {
  name: "FlashCards",
  props: {
    cartas: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    desc: { type: String },
    idElement: { type: Number },
    idColumn: { type: Number, default: null }
  },
  data() {
    return {
      instrucciones: this.desc,
      defaultSelected: null,
      cartasSelected: this.cartas,
      noCartas: noCartas,
      tipos: [
        { value: null, text: "Sin Texto / Imagen" },
        { value: 1, text: "Texto" },
        { value: 2, text: "Imagen" }
      ],
      showModal: false,
      showModal2: false,
      typeRecurso: null,
      typeRecurso2: null,
      dataProcessModal: null,
      dataProcessModal2: null
    };
  },
  components: {
    ModalRecursos,
    OptionsElement
  },
  methods: {
    openModalRecursos(tipo, carta) {
      this.typeRecurso = tipo;
      this.showModal = true;
      this.dataProcessModal = carta;
    },
    openModalRecursos2(tipo2, carta) {
      this.typeRecurso2 = tipo2;
      this.showModal2 = true;
      this.dataProcessModal = carta;
    },
    chooseRecurso(e) {
      this.dataProcessModal.data = e.file;
    },
    chooseRecurso2(e) {
      this.dataProcessModal.reverso = e.file;
    },
    onChangeCartas(number) {
      this.cartasSelected = [];
      var cartasArray = new Array(number);
      for (let i = 0; i < cartasArray.length; i++) {
        var cartaData = {
          id: i + 1,
          tipo: null,
          tipo2: null,
          flipped: false,
          data: "",
          reverso: ""
        };
        this.cartasSelected.push(cartaData);
      }
    },
    onChangeTipo(event, carta) {
      carta.data = "";
      carta.tipo = event;
    },
    onChangeTipo2(event, carta) {
      carta.reverso = "";
      carta.tipo2 = event;
    },
    onFileChange(e, carta) {
      var f = e.target.files[0];
      var type = e.target.files[0].type;
      var reader = new FileReader();

      reader.onload = (function(theFile) {
        return function(e) {
          var binaryData = e.target.result;
          var base64String = window.btoa(binaryData);
          carta.data = `data:${type};base64,${base64String}`;
        };
      })(f);
      reader.readAsBinaryString(f);
    },
    onFileChange2(e, carta) {
      var f = e.target.files[0];
      var type = e.target.files[0].type;
      var reader = new FileReader();

      reader.onload = (function(theFile) {
        return function(e) {
          var binaryData = e.target.result;
          var base64String = window.btoa(binaryData);
          carta.reverso = `reverso:${type};base64,${base64String}`;
        };
      })(f);
      reader.readAsBinaryString(f);
    },
    removeCarta(index) {
      this.$swal({
        type: "warning",
        title: "Eliminar una Carta",
        text: `¿Seguro que Deseas Eliminar la Carta No. ${index + 1}?`,
        showCancelButton: true,
        confirmButtonColor: "#285c4d",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "No, Cancelar"
      }).then(result => {
        if (result.value) {
          this.cartasSelected.splice(index, 1);
        }
      });
    },
    newCarta() {
      var i = this.cartasSelected.length;
      var cartaData = {
        id: i + 1,
        tipo: null,
        tipo2: null,
        flipped: false,
        data: "",
        reverso: ""
      };
      this.cartasSelected.push(cartaData);
    }
  },
  watch: {
    cartasSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "cartas",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.textarea {
  resize: none;
  text-align: center;
  margin-top: 50px;
}
.btn-select-recurso {
  margin-top: 20px;
  width: 100%;
  text-align: center;
}
.preview {
  margin-top: 20px;
  text-align: center;
  height: auto;
}
.img-thumb-card {
  width: 160px;
  height: 160px;
}
.audio-thumb-card {
  width: 100%;
}
#preview {
  margin-top: 20px;
  text-align: center;
}
</style>